import React from "react";
import { Star, Shield, Clock, Award, ThumbsUp, CheckCircle } from "lucide-react";
const trustBadges = [{
  icon: Star,
  title: "5-Star Rated",
  subtitle: "Google & Facebook"
}, {
  icon: Shield,
  title: "Licensed & Insured",
  subtitle: "Full Coverage"
}, {
  icon: Clock,
  title: "24/7 Emergency",
  subtitle: "Always Available"
}, {
  icon: Award,
  title: "Veteran-Owned",
  subtitle: "Proud to Serve TX"
}, {
  icon: ThumbsUp,
  title: "Free Estimates",
  subtitle: "No Hidden Fees"
}, {
  icon: CheckCircle,
  title: "Same-Day Service",
  subtitle: "Fast Response"
}];
export default function BrandLogos() {
  return <section className="w-full py-12 bg-white border-y border-[#e8f4ec]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-[#1B8439] mb-8">
          Why Kingwood Trusts Schaefer Garage Doors
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6">
          {trustBadges.map(badge => {
          const Icon = badge.icon;
          return <div key={badge.title} className="flex flex-col items-center text-center gap-2">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#e8f4ec]">
                  <Icon className="h-6 w-6 text-[#1B8439]" />
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900 leading-tight">{badge.title}</p>
                  <p className="text-xs text-gray-500 leading-tight">{badge.subtitle}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}